import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withFirebase } from '../Firebase'

const PlayButton = () => (
  <div className="videoNodePlayButton">
    <div className="videoNodePlayButtonIcon" />
  </div>
)

const VideoNode = ({ node, firebase }) => {
  const [videoPlaceHolder, setVideoPlaceHolder] = useState('')

  useEffect(() => {
    async function fetchThumbnail() {
      const video = await firebase.getVideoSnippet(node.text)
      setVideoPlaceHolder(video.thumbnail)
    }
    fetchThumbnail()
  }, [node, firebase])

  return (
    <div className="videoNode">
      <div className="videoNodeContent">
        <div className="videoNodeImage">
          <img src={videoPlaceHolder} alt="" draggable="false" loading="lazy" />
        </div>
        {node.title && node.title.length > 0 && (
          <div className="nodeImageTitle">{node.title}</div>
        )}
        <PlayButton />
      </div>
    </div>
  )
}

VideoNode.propTypes = {
  node: PropTypes.shape({
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  firebase: PropTypes.shape({
    getVideoSnippet: PropTypes.func,
  }),
}

export default withFirebase(VideoNode)
